import { and } from 'ricos-content';
import { extract } from 'ricos-content/libs/extract';
import { modify } from 'ricos-content/libs/modify';
import { Node_Type } from 'ricos-schema';

(undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.11.0
 */
var not = function (predicate) {
    return function (a) {
        return !predicate(a);
    };
};

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const isAnchorableAtomicPluginNode = (node) => {
  const { type } = node;
  return type === Node_Type.IMAGE || type === Node_Type.GALLERY || type === Node_Type.VIDEO || type === Node_Type.MAP || type === Node_Type.BUTTON || type === Node_Type.GIF || type === Node_Type.FILE;
};
const isAnchorableTextNode = (node) => {
  const { type } = node;
  return type === Node_Type.PARAGRAPH || type === Node_Type.BLOCKQUOTE || type === Node_Type.CODE_BLOCK || type === Node_Type.HEADING;
};
const isAnchorableNode = (node) => {
  return isAnchorableAtomicPluginNode(node) || isAnchorableTextNode(node);
};
const isEmptyImageNode = ({ imageData, type }) => {
  var _a, _b, _c, _d;
  return type === Node_Type.IMAGE && !(((_b = (_a = imageData == null ? void 0 : imageData.image) == null ? void 0 : _a.src) == null ? void 0 : _b.id) || ((_d = (_c = imageData == null ? void 0 : imageData.image) == null ? void 0 : _c.src) == null ? void 0 : _d.url));
};
const isEmptyTextNode = (node) => isAnchorableTextNode(node) && (node.nodes.length === 0 || node.type === Node_Type.BLOCKQUOTE && node.nodes[0].nodes.length === 0);
const isSelectedNode = (selectedNodeId) => (node) => {
  const { id } = node;
  return selectedNodeId === id;
};
const handleBlockquoteTextData = (nodes) => {
  return modify({ nodes }).filter((node) => node.type === Node_Type.BLOCKQUOTE).set((node) => {
    var _a;
    const nodes2 = node.nodes;
    if (nodes2.length === 0) {
      return node;
    }
    nodes2[0].textData = (_a = nodes2[0].nodes[0]) == null ? void 0 : _a.textData;
    return __spreadProps(__spreadValues({}, node), {
      nodes: nodes2
    });
  }).nodes;
};
const getAnchorableNodesQuery = (contentExtractor, selectedNodeId) => {
  const anchorableNodes = contentExtractor.filter(
    and([
      isAnchorableNode,
      not(isEmptyImageNode),
      not(isEmptyTextNode),
      not(isSelectedNode(selectedNodeId))
    ])
  ).get();
  const paragraphIdsToCleanup = extract(anchorableNodes).filter((node) => anchorableNodes.some((n) => {
    var _a;
    return node.id === ((_a = n.nodes[0]) == null ? void 0 : _a.id);
  })).map((node) => node.id).get();
  const anchorableNodesWithoutDuplications = anchorableNodes.filter(
    (node) => !(paragraphIdsToCleanup.includes(node.id) && node.type === Node_Type.PARAGRAPH)
  );
  const finalAnchorableNodes = handleBlockquoteTextData(anchorableNodesWithoutDuplications);
  return finalAnchorableNodes;
};

export { getAnchorableNodesQuery, isAnchorableAtomicPluginNode };
//# sourceMappingURL=getAnchorableNodesQuery.js.map
